import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

export const Breadcrumbs = ({ items }) => {
  // Generate schema markup
  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href ? `https://passionofaroma.com${item.href}` : undefined,
    })),
  };

  return (
    <>
      {/* Schema Markup */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />

      {/* Breadcrumb UI */}
      <nav aria-label="Breadcrumb" className="py-4" data-testid="breadcrumbs">
        <ol className="flex items-center flex-wrap gap-2 text-sm">
          <li>
            <Link
              to="/"
              className="text-gray-400 hover:text-[#D4AF37] transition-colors"
              data-testid="breadcrumb-home"
            >
              <Home className="h-4 w-4" />
            </Link>
          </li>
          {items.map((item, index) => (
            <React.Fragment key={index}>
              <li className="text-[#D4AF37]">
                <ChevronRight className="h-4 w-4" />
              </li>
              <li>
                {item.href ? (
                  <Link
                    to={item.href}
                    className="text-gray-400 hover:text-[#D4AF37] transition-colors"
                    data-testid={`breadcrumb-${index}`}
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span className="text-[#0B1F3B] font-medium" data-testid={`breadcrumb-${index}`}>
                    {item.label}
                  </span>
                )}
              </li>
            </React.Fragment>
          ))}
        </ol>
      </nav>
    </>
  );
};

export default Breadcrumbs;
